import React from 'react';
import { usePlaytechVariables } from 'js/components/system/App/hooks/usePlaytechVariables';

export const PlaytechVariables: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [{ variables, isLoading }] = usePlaytechVariables();

    if (!variables || isLoading) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
};
